import { jsx as n } from "react/jsx-runtime";
import { tv as e } from "../tailwind-variants.config.js";
const t = e({
  base: "jm-font-paragraph-2 jm-w-fit jm-px-1 jm-text-center jm-rounded-md group-disabled:jm-bg-jutro-new-warm-gray-100 jm-text-white group-disabled:jm-text-jutro-new-warm-gray-800",
  variants: {
    isClickable: {
      true: "jm-cursor-pointer"
    }
  }
}), m = e({
  extend: t,
  variants: {
    color: {
      blue: "jm-bg-jutro-new-blue-100 jm-text-jutro-new-warm-gray-800",
      gray: "jm-bg-jutro-new-warm-gray-100 jm-text-jutro-new-warm-gray-800",
      green: "jm-bg-jutro-new-green-100 jm-text-jutro-new-green-700",
      rose: "jm-bg-jutro-new-rose-100 jm-text-jutro-new-rose-800",
      orange: "jm-bg-jutro-new-orange-100 jm-text-jutro-new-orange-700",
      teal: "jm-bg-jutro-new-teal-100 jm-text-jutro-new-teal-800",
      "black-or-white": "jm-bg-white jm-text-jutro-new-cool-gray-800",
      "medium-gray": "jm-bg-jutro-new-warm-gray-200 jm-text-jutro-new-warm-gray-800"
    }
  },
  defaultVariants: {
    color: "blue"
  }
}), g = e({
  extend: t,
  variants: {
    color: {
      blue: "jm-bg-jutro-new-blue-600",
      gray: "jm-bg-jutro-new-warm-gray-700",
      green: "jm-bg-jutro-new-green-600",
      rose: "jm-bg-jutro-new-rose-700",
      orange: "jm-bg-jutro-new-orange-700",
      teal: "jm-bg-jutro-new-teal-600",
      "black-or-white": "jm-bg-jutro-new-warm-gray-900",
      "medium-gray": "jm-bg-jutro-new-warm-gray-200 jm-text-jutro-new-warm-gray-800"
    }
  },
  defaultVariants: {
    color: "blue"
  }
}), s = ({ text: a, color: o, variant: j = "default", onClick: r }) => /* @__PURE__ */ n(
  "div",
  {
    className: (j === "inverted" ? g : m)({ color: o, isClickable: !!r }),
    onClick: r,
    children: a
  }
);
export {
  s as Tag
};
//# sourceMappingURL=index.js.map
